var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10508 6.90007C4.30508 1.71007 12.1201 1.71007 13.3051 6.90007C14.0101 9.94507 12.0751 12.5251 10.3951 14.1301C9.16508 15.3001 7.23008 15.2851 6.00008 14.1301C4.33508 12.5251 2.40008 9.94507 3.10508 6.90007Z",
    stroke: "#1B9CF9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.605 24.9001C23.805 19.7101 31.665 19.7101 32.865 24.9001C33.57 27.9451 31.635 30.5251 29.94 32.1301C28.71 33.3001 26.76 33.2851 25.53 32.1301C23.835 30.5251 21.9 27.9451 22.605 24.9001Z",
    stroke: "#1B9CF9",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5H22.02C24.795 7.5 26.085 10.935 24 12.765L12.015 23.25C9.93004 25.065 11.22 28.5 13.98 28.5H18",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22932 8.25H8.24666",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7293 26.25H27.7467",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouting);
export default __webpack_public_path__ + "static/media/routing.343533da1c248e15ed400cedbb97c75f.svg";
export { ForwardRef as ReactComponent };